import * as React from 'react';
import { Box, Typography, Button, Stack, useTheme } from '@mui/material';
import BackButton from '../../../components/BackButton';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { useState } from 'react';
import { useAuthContext } from '../../../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';
import BgBoxOld from '../../../components/BgBoxOld';
import ImageUpload from '../../../components/ImageUpload';
import { useEffect } from 'react';
import { getProjByComServ } from '../../../services/proj-service';
import CustomDropDown from '../../../components/CustomDropDown';
import { isNotEmpty } from '../../../utils/format';
import QueryKey from '../../../utils/QueryKey';
import { useQuery } from 'react-query';
import { createDeptUserServ, getDeptDDByProj } from '../../../services/dept-service';
import constants from '../../../utils/Constants';


const userTypeArr = [
  ...(constants.needRequestor ? [{ value: "requestor", label: "Requestor" }] : []),
  { value: "approver", label: "End User" },];


function CreateDeptEmpPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { comId, projIdStrg } = location.state || {};
  const { setLoadingScreen, setNavComValue, ctxtUser } = useAuthContext();
  const [formErrors, setFormErrors] = useState({});
  const [img, setImg] = useState({ fileKey: "", fileUrl: "" });
  const txtFieldSx = { width: 300, height: 30, borderRadius: 1 }
  const [selection, setSelection] = useState({ userType: userTypeArr[0].value, projIdStrg: projIdStrg ?? "", deptId: "" });
  const { isLoading, isError, error, data: projData } = useQuery([QueryKey.projListDD, comId, ctxtUser?.userId, projIdStrg], () =>
    getProjByComServ({ userId: ctxtUser?.userId, type: "com" }),
    {
      enabled: (isNotEmpty(comId) && isNotEmpty(projIdStrg)),
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: false,
    })

  const { isLoading: isDeptLoading, isError: isDeptErr, error: deptErr, data: deptData } = useQuery([QueryKey.deptListDD, selection.projIdStrg],
    () => getDeptDDByProj({ projIdStrg: selection.projIdStrg }),
    {
      enabled: isNotEmpty(selection.projIdStrg),
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: false,
    })


  useEffect(() => {
    setLoadingScreen(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  useEffect(() => {
    setLoadingScreen(isDeptLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeptLoading]);


  useEffect(() => {
    if (!comId)
      navigate("/", { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comId])

  useEffect(() => {
    if (!projIdStrg) {
      notify("error", "The Contract Focal Point has no assigned projects. Please contact the admin to assign a project!")
      navigate("/", { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projIdStrg])

  useEffect(() => {
    setNavComValue({ comId })
    return () => setNavComValue({ comId: "" }); // Reset when leaving the page
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, comId]);


  function handleImgRemove() {
    setImg({ fileKey: "", fileUrl: "" })
  };

  function handleOnUpload({ fileKey, fileUrl }) {
    setImg({ fileKey, fileUrl })
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
    let errorsObj = validate(inputObject);
    setFormErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0)
      return;

    setLoadingScreen(true);
    try {
      const payload = {
        comId,
        deptId: isNotEmpty(selection.deptId) ? selection.deptId : null,
        username: inputObject.username,
        userType: selection.userType,
        empId: inputObject.empId,
        fName: inputObject.fName,
        lName: inputObject.lName,
        phoneNo: inputObject.phoneNo,
        profileImg: img.fileKey,
      }
      const { message } = await createDeptUserServ(payload);
      notify("success", message);
      navigate(`${route.cProjEmpList}`, { replace: true })
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setLoadingScreen(false);
  };

  function validate(values) {
    const errors = {};

    if (!values.fName)
      errors.fName = "Name is required!";

    if (!values.username)
      errors.username = "Email is required!";

    if (!values.userType)
      errors.userType = "Employee Role is required!";

    if (!values.deptId)
      errors.deptId = "Department is required!";

    return errors;
  };

  function handleDDChange(e) {
    const { name, value } = e.target;

    if (name === "projIdStrg")
      setSelection((e) => { return { ...e, projIdStrg: value, deptId: "" } });
    else if (name === "deptId")
      setSelection((e) => { return { ...e, deptId: value } });
    else
      setSelection((e) => { return { ...e, [name]: value } });
  }


  async function handleCancel() {
    navigate(`${route.cProjEmpList}`, { replace: true })
  }

  if (isDeptErr) {
    customAlert(deptErr);
    return <h2>Something went wrong</h2>
  }

  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  return (<form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
    <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5} width={"100%"}>
      <Stack width={"20%"}>
        <BackButton />
      </Stack>
      <Stack width={"60%"} alignItems={"center"}>
        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Create Employee </Typography>
      </Stack>
      <Stack width={"20%"} />
    </Stack>
    {deptData ? <BgBoxOld height={"93%"} py={1}>
      <Stack direction={"row"} height={"100%"} gap={6} mt={1} sx={{ position: "relative" }}>
        <Stack sx={{ width: "30%", height: "90%" }} gap={2}>
          <LabelTxtFieldInfo name="fName" errMsg={formErrors.fName} title="First Name *" {...txtFieldSx} />
          <LabelTxtFieldInfo name="lName" title="Last Name" {...txtFieldSx} />
          <LabelTxtFieldInfo name="username" errMsg={formErrors.username} title="Email ID (Username) *" {...txtFieldSx} />
          <LabelTxtFieldInfo name="phoneNo" title="Contact No" {...txtFieldSx} />
        </Stack>
        <Stack sx={{ width: "30%", height: "90%" }} gap={2}>
          <LabelTxtFieldInfo name="empId" title="Employee ID" {...txtFieldSx} />
          <CustomDropDown name="userType" errMsg={formErrors.userType} title={"Employee Role *"} {...txtFieldSx}
            handleDDChange={handleDDChange} ddArr={userTypeArr} defaultValue={userTypeArr[0].value} needNone={false} />
          <CustomDropDown readOnly={true} bgColor={"rgba(162, 214, 249, 0.18)"} defaultValue={selection?.projIdStrg} name="projIdStrg"
            title={"Project"} {...txtFieldSx} handleDDChange={handleDDChange} ddArr={projData?.projArr || []} />
          <CustomDropDown name="deptId" errMsg={formErrors.deptId} title={"Department *"} {...txtFieldSx} handleDDChange={handleDDChange} ddArr={deptData || []} />
        </Stack>
        <ImageUpload currentImage={img?.fileUrl} onUpload={handleOnUpload} onRemove={handleImgRemove} boxTitle={"Employee Profile"} btnName={"Upload Image"} />
        <Box sx={{ position: "absolute", bottom: 20, right: 20 }}>
          <Button variant="outlined" onClick={handleCancel} sx={{
            fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
            color: theme.palette.custom.btn, mr: 2,
          }}>CANCEL</Button>
          <Button variant="contained" type="submit"
            sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", }}>CREATE</Button>
        </Box>
      </Stack>
    </BgBoxOld> : <Stack alignItems={"center"} justifyContent={"center"} height={"70%"}>
      <Typography sx={{ fontSize: 16, color: "red" }}>This project doesn't have any departments. Please create a department before adding an employee!</Typography>
    </Stack>}
  </form>
  );
}

export default CreateDeptEmpPage;